import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SaveIcon from '@mui/icons-material/Save';
import useMessage from '../../util/useMessage';
import { useForm } from 'react-hook-form';
import SubmitButton from '../../ui/SubmitButton';
import InputText from '../../ui/InputText';
import BatchOperationservice from '../../service/MasterServices/BatchOperationService';
import ModulTipi from '../../enum/ModulTipi';
import EnumSelect from '../../ui/EnumSelect';

const BatchOperationCrudDialog = ({ open, onClose, data, crudTip, title }) => {


    const { t } = useTranslation();
    const showMessage = useMessage();
    const [crudtitle, SetCrudtitle] = useState("");

    const inputObject = {
        operationId: data?.operationId,
        operationName: data?.operationName,
        operationType: data?.operationType,
    }

    const { handleSubmit, control, reset, formState: { errors } } = useForm({
        defaultValues: {
            ...inputObject
        }
    });

    useEffect(() => {
        if (open) {
            reset({
                ...inputObject
            });
            setLoading(false);
            setStatusUpdated(false);
            if (crudTip == "Create") {
                SetCrudtitle(t(title) + " " + t("button.add"))
            } else {
                SetCrudtitle(t(title) + " " + t("button.update"))
            }
        }
    }, [open, reset]);

    const [loading, setLoading] = useState(false);

    const [statusUpdated, setStatusUpdated] = useState(false);

    const Create = async (input) => {
        const { resultObject } = await BatchOperationservice.create(
            {
                operationId: input.operationId,
                operationName: input.operationName,
                operationType: input.operationType,
            }
        );

        return resultObject;
    }

    const Update = async (input) => {
        const { resultObject } = await BatchOperationservice.update(
            {
                id: data?.id,
                operationId: input.operationId,
                operationName: input.operationName,
                operationType: input.operationType,
            }
        );

        return resultObject;
    }


    const onSubmit = async (input) => {
        if (loading)
            return false;

        try {
            setLoading(true);

            let status = false;
            if (crudTip == "Create") {
                status = await Create(input);
            } else {

                status = await Update(input);
            }

            setLoading(false);

            if (status) {
                setStatusUpdated(true);
                showMessage(t('message.created'));
            } else {
                showMessage(t('message.updateFailed'));
            }

            return status;

        } catch (error) {
            setLoading(false);

            console.log(error);
        }


    }

    const InsertForm = () => {
        return (
            <Grid container spacing={1} alignItems="center">

                <Grid item xs={12}>
                    <InputText
                        name="operationId"
                        label={t('label.operationId')}
                        defaultValue={data?.operationId}
                        error={errors?.operationId}
                        control={control}
                        rules={{ required: t('validation.required') }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <InputText
                        name="operationName"
                        label={t('label.operationName')}
                        defaultValue={data?.operationName}
                        error={errors?.operationName}
                        control={control}
                        rules={{ required: t('validation.required') }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <EnumSelect
                        name="operationType"
                        control={control}
                        label={t('label.operationType')}
                        rules={{ required: t('validation.required') }}
                        StatusEnum={ModulTipi}
                    />
                </Grid>



            </Grid>
        );

    }

    const UpdateForm = () => {

        return (
            <Grid container spacing={1} alignItems="center">

                <Grid item xs={12}>
                    <InputText
                        name="operationId"
                        label={t('label.operationId')}
                        error={errors?.operationId}
                        control={control}
                        rules={{ required: t('validation.required') }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <InputText
                        name="operationName"
                        label={t('label.operationName')}
                        error={errors?.operationName}
                        control={control}
                        rules={{ required: t('validation.required') }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Grid item xs={12}>
                        <EnumSelect
                            name="operationType"
                            control={control}
                            label={t('label.operationType')}
                            rules={{ required: t('validation.required') }}
                            StatusEnum={ModulTipi}
                        />
                    </Grid>

                </Grid>



            </Grid>
        );
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth={"xl"}
            scroll="paper"
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>
                    {crudtitle}
                </DialogTitle>

                <DialogContent dividers={true} style={{ display: 'flex', gap: '16px' }}>
                    {data ? UpdateForm() : InsertForm()}
                </DialogContent>
                <DialogActions>
                    {statusUpdated ? (
                        <Button onClick={onClose} color="primary">
                            {t('button.done')}
                        </Button>
                    ) : (
                        <React.Fragment>
                            <Button onClick={onClose} color="primary" disabled={loading}>
                                {t('button.cancel')}
                            </Button>
                            <SubmitButton loading={loading} startIcon={<SaveIcon />}>
                                {t('button.save')}
                            </SubmitButton>
                        </React.Fragment>
                    )}
                </DialogActions>

            </form>

        </Dialog>
    );

};


export default React.memo(BatchOperationCrudDialog);


